export enum ChasubleType {
  CenterDesign = 'center_design',
  CenterPatch = 'center_patch',
  TauOrphrey = 'tau_orphrey',
  DirectEmbroideryDesign = 'direct_embroidery_design',
  GothicStyle = 'gothic_style',
  Alb = 'alb',
  Plain = 'plain',
  Roman = 'roman',
  V1Orphrey = 'v1_orphrey',
  V1Plain = 'v1_plain',
}
